module.exports = __webpack_public_path__ + "static/media/sound.0af68239.gif";